import { ArrowDownIcon } from 'assets/icons';
import Label from 'Components/Form/Label';
import { uniq } from 'lodash';
import { ReactNode, useContext, useEffect } from 'react';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import { GroupContext, PreExpandedContext } from './context';
import { FilterSection } from './FilterSection';

export function FilterGroup({
  children,
  label,
  uuid,
  isDirty,
  onClear,
}: {
  children: ReactNode;
  label?: ReactNode;
  uuid: string;
  isDirty?: any;
  onClear: () => void;
}) {
  return (
    <GroupContext.Provider value={{ label, uuid, isDirty, onClear }}>
      <FilterSection>
        <AccordionItem uuid={uuid} className="w-full">
          <FilterGroupHeader />
          <AccordionItemPanel className="">{children}</AccordionItemPanel>
        </AccordionItem>
      </FilterSection>
    </GroupContext.Provider>
  );
}

function FilterGroupHeader() {
  const { onClear, isDirty, label } = useContext(GroupContext);
  return (
    <AccordionItemHeading className="my-0 px-2 py-1 flex w-full">
      <AccordionItemButton className="text-gray-700 capitalize w-full flex items-center  gap-2 m-0 font-semibold ">
        <Label className="text-green" label={label} />

        <AccordionItemState>
          {({ expanded }) => <ExpandButton expanded={expanded} />}
        </AccordionItemState>

        {isDirty && (
          <button
            className="w-5 h-5 ml-auto mr-4 flex items-center justify-center rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onClear();
            }}
          >
            <span className="rounded-full w-2 h-2  bg-green " />
          </button>
        )}
      </AccordionItemButton>
    </AccordionItemHeading>
  );
}

function ExpandButton({ expanded }: { expanded?: boolean }) {
  const { uuid } = useContext(GroupContext);
  const { setPreExpanded } = useContext(PreExpandedContext);

  useEffect(() => {
    setPreExpanded((list) =>
      expanded ? uniq(list.concat(uuid)) : list.filter((i) => i !== uuid),
    );
  }, [expanded]);
  return <ArrowDownIcon className={expanded ? 'transform rotate-180' : ''} />;
}
